export default {
  manual: 'Manual',
  filters: {
    status: 'Status',
    event_type: 'Event type',
  },
  columns: {
    event: 'Event',
    status: 'Status',
    attempts: 'Attempts',
    last_http_status: 'Last HTTP status',
    created_at: 'Created',
  },
  statuses: {
    pending: 'Pending',
    delivered: 'Delivered',
    failed: 'Failed',
  },
  buttons: {
    details: 'Details',
    resend: 'Resend',
  },
  detail: {
    title: 'Delivery details',
    event: 'Event',
    attempts: 'Attempts',
    no_attempts: 'No attempts yet.',
    no_response: 'no response',
    payload: 'Payload',
  },
  toasts: {
    load_error: 'Could not load the deliveries.',
    resend_error: 'Could not resend the delivery.',
    resent: 'Delivery queued for resend.',
  },
};
